import React from 'react'
import { InputMask } from 'primereact/inputmask'

export default function LtsInputMask(props) {
  const {
    onChange: onChangeProp,
    label,
    hidden,
    value = '',
    name,
    mask,
    unmask,
    autoClear,
    maxLength,
    autoFocus,
    keyfilter,
    style,
    disabled,
    className,
    ...rest
  } = props

  const handleChange = (event) => {
    onChangeProp?.(event.target.value)
  }

  return (
    <span className="p-float-label">
      <InputMask
        {...rest}
        mask={mask}
        unmask={unmask}
        autoClear={autoClear}
        value={value}
        onChange={handleChange}
        name={name}
        maxLength={maxLength}
        autoFocus={autoFocus}
        keyfilter={keyfilter}
        style={style}
        disabled={disabled}
        className={className}
      />
      {label && !hidden && <label>{label}</label>}
    </span>
  )
}
